import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

export const RestrictionReason = {
  CLIENT_SENSITIVE: "Client sensitive",
  FACES_PRIVACY: "Faces / privacy",
  SAFETY_INCIDENT: "Safety incident",
  INTERNAL_ONLY: "Internal only",
  OTHER: "Other",
} as const;

export type RestrictionReasonValue = (typeof RestrictionReason)[keyof typeof RestrictionReason];

export const RESTRICTION_REASON_OPTIONS: { label: string; value: RestrictionReasonValue }[] = [
  { label: "Client sensitive", value: RestrictionReason.CLIENT_SENSITIVE },
  { label: "Faces / privacy", value: RestrictionReason.FACES_PRIVACY },
  { label: "Safety incident", value: RestrictionReason.SAFETY_INCIDENT },
  { label: "Internal only", value: RestrictionReason.INTERNAL_ONLY },
  { label: "Other", value: RestrictionReason.OTHER },
];

export class MarketingAsset extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare file: number;
  declare caption: string;
  declare altText: string;
  declare aiObservations: string[];
  declare visibilityWarnings: string[];
  declare isRestricted: boolean;
  declare restrictionReason: RestrictionReasonValue | null;
  declare tags: number[];
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "MarketingAsset";
  }

  static get fields() {
    return [
      "id",
      "board",
      "file",
      "caption",
      { name: "altText", dataSource: "alt_text" },
      { name: "aiObservations", dataSource: "ai_observations" },
      { name: "visibilityWarnings", dataSource: "visibility_warnings" },
      { name: "isRestricted", dataSource: "is_restricted", type: "boolean", defaultValue: false },
      { name: "restrictionReason", dataSource: "restriction_reason" },
      "tags",
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }

  get fileRecord() {
    if (this.project) {
      return this.project.getCrudStore(STORE_KEYS.boardFilesStore)?.getById(this.file);
    }
    return null;
  }

  get tagRecords() {
    if (this.project && this.tags?.length) {
      const tagStore = this.project.getCrudStore(STORE_KEYS.marketingTagStore);
      return this.tags.map((tagId: number) => tagStore?.getById(tagId)).filter(Boolean);
    }
    return [];
  }
}

// @ts-expect-error - exposeProperties is internal method
MarketingAsset.exposeProperties();
